import { render, staticRenderFns } from "./book-detail.vue?vue&type=template&id=552a40fc"
import script from "./book-detail.vue?vue&type=script&lang=js"
export * from "./book-detail.vue?vue&type=script&lang=js"
import style0 from "./book-detail.vue?vue&type=style&index=0&id=552a40fc&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports